import * as Sentry from '@sentry/gatsby';

Sentry.init({
	dsn: process.env.GATSBY_SENTRY_DSN,
	environment: process.env.GATSBY_ENVIRONMET,
	tunnel: `${process.env.GATSBY_BACKEND_URL}/monitoring-tunnel/`,
	enabled: ['production'].indexOf(process.env.NODE_ENV) !== -1,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
		Sentry.captureConsoleIntegration({
			levels: ['error', 'warn'],
		}),
	],
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
	// Capture Replay for 10% of all sessions,
	// plus for 100% of sessions with an error
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	//release: 'npm@6.14.14',
	browserTracingOptions: {
		// disable creating spans for XHR requests
		traceXHR: false,
	}
});